import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/promo/[code]/page.tsx");
